namespace Advant.Crossroads {
    export interface IHighSchoolService {
        getCfncSchool: (name: string, ceebCode: string) => angular.IPromise<IHighSchool>;
        transcriptSchoolExists: (ceebCode) => angular.IPromise<boolean>;
        fafsaSchoolExists: (fafsaId: string) => angular.IPromise<boolean>;
        generateCrmId: () => angular.IPromise<string>;
        addSchoolToCfnc: (highSchool: IHighSchool, addDwya: boolean, addLsi: boolean) => angular.IPromise<any>;
        addSchoolToTranscripts: (highSchool: IHighSchool) => angular.IPromise<any>;
        addSchoolToFafsa: (fafsaId: string) => angular.IPromise<any>;
        deleteCfncSchool: (ceebCode: string) => angular.IPromise<any>;
        deleteTranscriptSchool: (ceebCode: string) => angular.IPromise<any>;
        deleteFafsaSchool: (fafsaId: string) => angular.IPromise<any>;
        ceebCodeExists: (ceebCode: string) => angular.IPromise<any>;
    }


    export class HighSchoolService implements IHighSchoolService {
        static serviceId: string = "highSchoolService";
        static $inject = ["Restangular", "common"]

        log: (msg, data?, showHowl?) => void;
        logError: (msg, data?, showHowl?) => void;
        logSuccess: (msg, data?, showHowl?) => void;

        constructor(private Restangular: Restangular.IService, private common: ICommonService) { }

        getCfncSchool = (name: string, ceebCode: string): angular.IPromise<IHighSchool> => {
            if (name && ceebCode) {
                var params = { name: name, ceebCode: ceebCode };
                return this.Restangular.one("lookup").one("school").one("cfncSchoolsExist")
                    .get<IHighSchool>(params);
            }
            else {
                return this.common.$q.when(null);
            }
        };

        transcriptSchoolExists = (ceebCode: string): angular.IPromise<boolean> => {
            if (ceebCode) {
                return this.Restangular.one("lookup").one("school").one("transcriptsSchoolExists", ceebCode)
                    .get<boolean>();
            }
            else {
                return this.common.$q.when(false);
            }
        };

        fafsaSchoolExists = (fafsaId: string): angular.IPromise<boolean> => {
            if (fafsaId) {
                return this.Restangular.one("lookup").one("school").one("fafsaSchoolExists", fafsaId)
                    .get<boolean>();
            }
            else {
                return this.common.$q.when(false);
            }
        };

        generateCrmId = (): angular.IPromise<string> => {
            return this.Restangular.one("lookup").one("school").one("generateCrmId")
                .get<string>();
        };

        addSchoolToCfnc = (highSchool: IHighSchool, addDwya: boolean, addLsi: boolean): angular.IPromise<any> => {
            var params = { name: highSchool.name, ceebCode: highSchool.ceebCode, crmId: highSchool.crmId, dwyaLicense: addDwya, lsiLicense: addLsi };
            return this.Restangular.one("lookup").one("school").all("updateCfncSchool").post(params);
        };

        addSchoolToTranscripts = (highSchool: IHighSchool): angular.IPromise<any> => {
            var params = {
                name: highSchool.name,
                ceebCode: highSchool.ceebCode,
                address1: highSchool.address.street1,
                address2: highSchool.address.street2,
                city: highSchool.address.city,
                state: highSchool.address.state,
                country: highSchool.address.country,
                zipCode: highSchool.address.zip
            };
            return this.Restangular.one("lookup").one("school").all("updateTranscriptsSchool").post(params);
        };

        addSchoolToFafsa = (fafsaId: string): angular.IPromise<any> => {
            var params = { schoolCode: fafsaId };
            return this.Restangular.one("lookup").one("school").all("updateFafsaSchool").post(params);
        };

        deleteCfncSchool = (ceebCode: string): angular.IPromise<any> => {
            var params = { ceebCode: ceebCode };
            return this.Restangular.one("lookup").one("school").all("deleteCfncSchool").post(params);
        };

        deleteTranscriptSchool = (ceebCode: string): angular.IPromise<any> => {
            var params = { ceebCode: ceebCode };
            return this.Restangular.one("lookup").one("school").all("deleteTranscriptSchool").post(params);
        };

        deleteFafsaSchool = (fafsaId: string): angular.IPromise<any> => {
            var params = { schoolCode: fafsaId };
            return this.Restangular.one("lookup").one("school").all("deleteFafsaSchool").post(params);
        };

        ceebCodeExists = (ceebCode: string): angular.IPromise<boolean> => {
            if (ceebCode) {
                return this.Restangular.one("lookup").one("school").one("ceebCodeExists", ceebCode)
                    .get<boolean>();
            }
            else {
                return this.common.$q.when(false);
            }
        };
    }

    angular.module("app").service(HighSchoolService.serviceId, HighSchoolService);
}